import { Button, Container, Typography} from '@mui/material'
import { useTranslation } from "react-i18next"

import Spacer from "../../../atoms/Spacer/Spacer"

import useTrackPageView from "../../../../helpers/hooks/use-track-page-view"
import styles from './SubscriptionGiftSuccessPage.module.css'
import { useNavigate } from "react-router-dom"
import { Route } from '../../../../router'
import { useContext, useEffect } from 'react'
import { AppContext } from '../../../../stores/App/AppStore'
import { useSubscriptionGiftRepository } from '../../../../repositories/SubscriptionGift/use-subscription-gift-repository'
import { UserContext } from '../../../../stores/User/UserStore'
import { logLandingPageAction } from '../../../../clients/logger'
import GtmEventName from '../../../../helpers/analytics/GtmEventName'
import { subscriptionStatusPageCopyShareCodeMessageTemplate } from '../../../../helpers/logging/templates'
import useGoogleTagManager from '../../../../helpers/analytics/use-google-tag-manager'

const SubscriptionGiftSuccessPage = () => {

    const { t } = useTranslation()
    const { trackButtonClick } = useGoogleTagManager()
    const { state: appState } = useContext(AppContext)
    const { state: userState } = useContext(UserContext)
    const { retrieveGiftBanners } = useSubscriptionGiftRepository()

    const navigate = useNavigate()

    useTrackPageView(`Subscription Gift Payment Success Page`)

    useEffect(() => {
        if (!appState.giftBanners){
            retrieveGiftBanners()
        }
    }, [])

    const handleClose = () => {
        navigate(`${Route.HOME}`)
    }

    const handleShare = async () => {
        try {
            const redemptionLink = `${process.env.REACT_APP_STARTER_DOMAIN_NAME}/subscription-gift/redemption-landing/${userState.subscriptionGift?.code}`
            await navigator.clipboard.writeText(`${redemptionLink}`)
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: `Subscription Gift Redemption Link`,
                        text: `Hi there! I've purchased NTUC Starter Membership for you. Get Started with Starter: ${redemptionLink}`,
                    })
                    trackButtonClick(GtmEventName.SUBSCRIPTION_GIFT_REDEMPTION_SHARE_CLICK, `${redemptionLink}`)
                    logLandingPageAction(subscriptionStatusPageCopyShareCodeMessageTemplate(`${userState.subscriptionGift?.code}`), `myInfo`)
                } catch (err) {
                    logLandingPageAction(`Encountered error while sharing subscription gift code: ${userState.subscriptionGift?.code}, error: ${err}`, `myInfo`)
                }
            } else {
                alert(`Sharing not supported on this device`)
            }
        } catch (err) {
            console.error(`Failed to copy: `, err)
        }
    }

    return (
        <Container className={styles.container}>
            <img className={styles.successImg} src={appState.giftBanners?.paymentSuccessImg} alt="Subscription Gift Success" />
            <Spacer height={24} />
            <Typography variant="h3">{t(`subscription_gift_success_header`)}</Typography>
            <Spacer height={24} />
            <Typography variant="h6" className={styles.successText}>{t(`subscription_gift_success_text`)}</Typography>
            <Spacer height={24} />
            <Typography variant="h6" className={styles.successText}>{t(`subscription_gift_success_text_2`)}</Typography>
            <Spacer height={24} />
            <Typography variant="h6" className={styles.successText}>{t(`subscription_gift_success_text_3`)}</Typography>
            <Spacer height={12} />
            <Typography variant="h6" className={styles.successText}>{t(`subscription_gift_success_text_4`)}</Typography>
            <Spacer height={12} />
            <Typography variant="h6" className={styles.successText}>{t(`subscription_gift_success_text_5`)}</Typography>
            <Spacer height={24} />
            <Button variant='contained' onClick={handleShare} fullWidth>{t(`share_with_recipient`)}</Button>
            <Spacer height={12} />
            <Button variant='outlined' onClick={handleClose} fullWidth>{t(`pwa_instructions_close`)}</Button>
        </Container>
    )
}

export default SubscriptionGiftSuccessPage